"use client";
import React from "react";
import { TurnrTableCell, TurnrTableRow } from "~/components/table/TurnrTableSmart.jsx";
import { TurnrButton } from "~/components/buttons/TurnrButton";
import { CHIP_COLOR_TYPES, CustomChip } from "~/components/chips/CustomChip.jsx";
import QualityCheckRemoveItemButton from "../QualityCheckRemoveItemButton";
import { ReportItemTableCellProduct } from "../ReportItemRow";

export default function AddItemRow({ appProps, orderItem, customItem, isAlreadyAdded, onAddItem, onRemoveItem, removeTooltipContent }) {
    return (
        <>
            <TurnrTableRow>
                <ReportItemTableCellProduct
                    appProps={appProps}
                    orderItem={orderItem}
                    customItem={customItem}
                    style={{
                        opacity: isAlreadyAdded && 0.5,
                    }}
                />
                <TurnrTableCell tight fullWidth>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "14px",
                        }}
                    >
                        {isAlreadyAdded ? (
                            <CustomChip label={"Added"} colorType={CHIP_COLOR_TYPES.DONE} />
                        ) : (
                            <TurnrButton variant="outlined" size={"small"} onClick={() => onAddItem(orderItem)}>
                                Add item
                            </TurnrButton>
                        )}
                        <QualityCheckRemoveItemButton onClick={onRemoveItem} removeTooltipContent={removeTooltipContent} />
                    </div>
                </TurnrTableCell>
            </TurnrTableRow>
        </>
    );
}
